import React from "react";
import { FaBuildingShield, FaLock, FaUserShield } from "react-icons/fa6";
import secac from "../assets/banner4.jpg";

export default function SecurityAC() {
  const features = [
    {
      icon: <FaLock size={20} className="text-primary" />,
      text: "Secure digital operating practices that support continuity and stronger day-to-day control.",
    },
    {
      icon: <FaUserShield size={20} className="text-primary" />,
      text: "Business continuity thinking that helps teams protect essential services and workflows.",
    },
    {
      icon: <FaBuildingShield size={20} className="text-primary" />,
      text: "Technology environments shaped to be dependable, resilient, and responsible.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Extended Capability</div>
          <h2 className="main-section-title">Secure Workplace & Continuity Support</h2>
          <p className="section-copy">
            Nova Technologies helps organizations think beyond implementation to the secure
            and reliable operation of critical digital environments.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={secac} alt="Secure Workplace and Continuity Support" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Reliability and trust are essential to digital transformation. This capability
            area supports organizations that want stronger continuity planning, better
            operational safeguards, and more confidence in how their digital environment is
            managed.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Review operational risks and critical continuity requirements.</li>
            <li>Identify practical safeguards and resilience improvements.</li>
            <li>Align supporting systems and processes with continuity priorities.</li>
            <li>Refine the environment as requirements evolve.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
